export default '/build/c9194c50.svg'